import { Skeleton } from '../Skeleton';
import { RewardCoin } from '../SVGIcons/RewardCoin';
import styles from './rwlabel.module.sass';
import cn from 'classnames';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    isLoading?: true;
    label?: string; // Optional when loading
    url?: string; // Optional when loading
}

interface LoadedProps extends BaseProps {
    isLoading?: false;
    label: string; // Required when not loading
    url: string; // Required when not loading
}

type RewardLabelProps = LoadingProps | LoadedProps;

export const RewardLabel = ({ label, isLoading, url, ...props }: RewardLabelProps) => {
    if (isLoading) {
        return (
            <div {...props} className={cn(styles.rwlabel, props.className)}>
                <Skeleton absolute />
            </div>
        );
    }

    return (
        <div {...props} className={cn(styles.rwlabel, props.className)}>
            <img src={url} alt={'gamificationPointsImage'} width={48} height={48} />
            <span>{label}</span>
        </div>
    );
};
